import React, { useState, useEffect, forwardRef, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';

import Close from '@material-ui/icons/Close';
import styles from 'assets/jss/material-dashboard-pro-react/views/notificationsStyle.js';
import { WithApp } from 'contexts/appContext';

import { wsUpdate, wsCreate } from 'services/WService';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const useStyles = makeStyles(styles);

export default WithApp(function Modal({ fullWidth = false, maxWidth = false, ...props }) {
  const classes = useStyles();
  const {
    saveButtonLabel = 'Guardar',
    closeButtonLabel = 'Cerrar',
    onSubmit = undefined,
    title,
    model,
    primaryKey,
    setOpen,
    dataChanging,
    setDataChanging,
    dataForce,
    entity,
    reload,
    responseData,
    showNotify,
    arrDataResponse,
    hideSave,
    hideClose,
    disabledSave,
    footerComponent = undefined,
    noValidate = undefined,
    handleCloseDisabled = false,
  } = props;

  const [openModal, setOpenModal] = useState(false);
  const form = useRef(null);
  const uniqueKey = primaryKey ?? 'id'; //puede recibir cualquier otro id con este prop
  //(usar en caso de que el ID del model no sea un "id", example: DocEntry, etc.)

  const [state, setState] = useState(model.state);
  const [disableButton, setDisableButton] = useState(false);

  const handleClose = () => {
    if (handleCloseDisabled === true) return;
    setOpenModal(false);
    setOpen({ open: false });
    if (setDataChanging) setDataChanging({});
  };

  function handleSubmit(e) {
    e.preventDefault();
    delete model['open'];
    if (dataChanging) delete dataChanging['open'];

    let data = {};
    for (let input of form.current.querySelectorAll('[name]')) {
      data[input.name] = input.value;
    }

    let concat = data;
    if (dataChanging) Object.assign(data, dataChanging);

    saveData(concat);
  }

  async function saveData(data) {
    setDisableButton(true);
    let response = {};
    if (!!props.state) {
      data.state = state;
    }

    if (onSubmit !== undefined) {
      try{
        await onSubmit(data);
        setDisableButton(false);
        handleClose();
        return;
      }catch(ex){
        setDisableButton(false);
        return;
      }
    } else {
      if (!!model[uniqueKey]) {
        let newData = {};
        for (let key of Object.keys(data)) {
          if (model[key] != data[key]) {
            newData[key] = data[key];
          }
        }

        //caso especial para fuerza de venta y otros
        if (dataForce) Object.assign(newData, dataForce);

        /* console.log('editando', newData); */
        response = await wsUpdate(entity, model[uniqueKey], newData);
      } else {
        //caso especial para fuerza de venta y otros
        if (dataForce) Object.assign(data, dataForce);

        /* console.log('creando', data); */
        response = await wsCreate(entity, data);
      }
    }

    if (response.success) {
      handleClose();
      if (reload) reload();
      //caso especial cuando quiera retornar el response (example: seller)  props is funcion
      if (responseData) responseData(response);

      showNotify(response.message);
      setDisableButton(false);
    } else {
      setDisableButton(false);
      if (arrDataResponse) {
        showNotify(`${response.message}\n${response?.data ? response.data : ''}`, 'error');
      } else {
        showNotify(response.message, 'error');
      }
    }
  }

  useEffect(() => {
    if (model.open) {
      setOpenModal(true);
      !!model.state ? setState(model.state) : setState('A');
    } else {
      setOpenModal(false);
    }
  }, [model]);

  return (
    <GridContainer>
      <GridItem>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={openModal}
          TransitionComponent={Transition}
          onClose={handleClose}
          PaperComponent={PaperComponent}
        >
          <DialogTitle disableTypography style={{ cursor: 'move' }} id="draggable-dialog-title">
            <Button
              justIcon
              className={classes.modalCloseButton}
              key="close"
              color="transparent"
              onClick={handleClose}
            >
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle} style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {title}
            </h4>
          </DialogTitle>
          <form onSubmit={handleSubmit} ref={form} noValidate={noValidate}>
            <DialogContent className={classes.modalBody} style={{ minWidth: '400px' }}>
              {props.children}
              {!!props.state ? (
                <FormControl fullWidth margin="normal" size="small" error={state === ''}>
                  <InputLabel>Estado</InputLabel>
                  <Select
                    value={state || 'A'}
                    inputProps={{
                      name: 'state',
                    }}
                    onChange={(e) => {
                      setState(e.target.value);
                    }}
                  >
                    <MenuItem value="A">Activo</MenuItem>
                    <MenuItem value="I">Inactivo</MenuItem>
                  </Select>
                </FormControl>
              ) : undefined}
            </DialogContent>
            <DialogActions className={classes.modalFooter}>
              {footerComponent}
              {hideSave !== true && (
                <Button
                  type="submit"
                  color={props.themeContext.buttonColorSuccess}
                  size="sm"
                  disabled={disabledSave ? disabledSave : disableButton}
                >
                  {saveButtonLabel}
                </Button>
              )}
              {hideClose !== true && (
                <Button
                  onClick={() => handleClose()}
                  color={props.themeContext.buttonColorDanger}
                  size="sm"
                  disabled={handleCloseDisabled === true}
                >
                  {closeButtonLabel}
                </Button>
              )}
            </DialogActions>
          </form>
        </Dialog>
      </GridItem>
    </GridContainer>
  );
});
